// /zh-Hans, pt-BR, ar, es, en;q=0.8
// header参数
let lang_map_header = {
    "en": 'en',
    "zh": 'zh-Hans',
    "por": 'pt-BR'
}

function findKey (value, compare = (a, b) => a === b) {
    return Object.keys(lang_map_header).find(k => compare(lang_map_header[k], value))
  }
  
export function receive(lang) {
    return findKey(lang);
}
export function send(lang) {
    return lang_map_header[lang]
}

// web页面 与后端

let lang_map_web = {
    "en":'en',
    "zh":"zh-hans",
    "por":"pt-br"
}

function findKey_web (value, compare = (a, b) => a === b) {
    return Object.keys(lang_map_web).find(k => compare(lang_map_web[k], value))
  }

export function receive_web(lang) {
    return findKey_web(lang);
}
export function send_web(lang) {
    return lang_map_web[lang]
}

// 与app
let lang_map_app = {
    "en":'en',
    "zh":"zh_hans",
    "por":"pt_br"
}

function findKey_app (value, compare = (a, b) => a === b) {
    return Object.keys(lang_map_app).find(k => compare(lang_map_app[k], value))
  }

export function receive_app(lang) {
    return findKey_app(lang);
}
export function send_app(lang) {
    return lang_map_app[lang]
}

// 与支付

let lang_map_pay = {
    "en":'en',
    "zh":"zh",
    "por":"pt",
    "es":'es'
}

function findKey_pay (value, compare = (a, b) => a === b) {
    return Object.keys(lang_map_pay).find(k => compare(lang_map_pay[k], value))
  }

export function receive_pay(lang) {
    return findKey_pay(lang);
}
export function send_pay(lang) {
    return lang_map_pay[lang]
}

// 与货币

let lang_map_prices = {
    "en":'USD',
    "zh":"USD",
    "por":"BRL",
    "es":'BRL'
}

function findKey_prices (value, compare = (a, b) => a === b) {
    return Object.keys(lang_map_prices).find(k => compare(lang_map_prices[k], value))
  }

export function receive_prices(lang) {
    return findKey_prices(lang);
}
export function send_prices(lang) {
    return lang_map_prices[lang]
}